import { AbsenceType } from '@lmc/ts-common'
import { ABSENCE_TYPES_URL, ABSENCE_TYPES_QUERY_KEY } from './queryConstants'
import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'

export type AbsenceTypesFormType = {
  absenceTypes: AbsenceType[]
}

type UseAbsenceTypesListReturn = {
  absenceTypes: AbsenceType[]
  isAbsenceTypesLoading: boolean
  refetch: () => void
}

export const useAbsenceTypesList = (): UseAbsenceTypesListReturn => {
  const {
    data: absences,
    isLoading,
    refetch,
  } = useQuery(
    [ABSENCE_TYPES_QUERY_KEY] as string[],
    () =>
      getJSON({
        url: ABSENCE_TYPES_URL,
        isRota: true,
      }),
    { enabled: true }
  )

  return {
    absenceTypes: absences?.data || [],
    isAbsenceTypesLoading: isLoading,
    refetch,
  }
}
